import React, { useState } from 'react';
import { useAuth } from './AuthProvider';
import { User, LogOut, ChevronDown } from 'lucide-react';

import { STAFF_ROLE_LABELS } from '../types/staffPlatform';

const UserProfile: React.FC = () => {
  const { user, logout, staffProfile, staffRole } = useAuth();
  const [isOpen, setIsOpen] = useState(false);

  const handleLogout = async () => {
    try {
      await logout();
    } catch (error) {
      console.error('Logout error:', error);
    }
  };

  if (!user) return null;

  const getInitials = (name: string) => {
    return name
      .split(' ')
      .map(word => word.charAt(0))
      .join('')
      .toUpperCase()
      .slice(0, 2);
  };

  return (
    <div className="relative">
      <button
        onClick={() => setIsOpen(!isOpen)}
        className="flex items-center space-x-3 p-2 rounded-lg hover:bg-gray-100 transition-colors"
      >
        <div className="h-8 w-8 bg-sunbeth-orange-600 rounded-full flex items-center justify-center">
          <span className="text-sm font-medium text-white">
            {getInitials(user.name || user.username || 'U')}
          </span>
        </div>
        <div className="text-left">
          <p className="text-sm font-medium text-gray-900">
            {user.name || user.username || 'User'}
          </p>
          <p className="text-xs text-gray-500">
            {staffRole ? STAFF_ROLE_LABELS[staffRole] : user.username || user.email || 'PMO Staff'}
          </p>
        </div>
        <ChevronDown className="h-4 w-4 text-gray-400" />
      </button>

      {isOpen && (
        <>
          {/* Backdrop */}
          <div
            className="fixed inset-0 z-10"
            onClick={() => setIsOpen(false)}
          />
          
          {/* Dropdown */}
          <div className="absolute right-0 mt-2 w-64 bg-white rounded-lg shadow-lg border border-gray-200 z-20">
            <div className="p-4 border-b border-gray-200">
              <div className="flex items-center space-x-3">
                <div className="h-10 w-10 bg-sunbeth-orange-600 rounded-full flex items-center justify-center">
                  <span className="text-sm font-medium text-white">
                    {getInitials(user.name || user.username || 'U')}
                  </span>
                </div>
                <div>
                  <p className="text-sm font-medium text-gray-900">
                    {user.name || user.username || 'User'}
                  </p>
                  <p className="text-xs text-gray-500">
                    {staffRole ? STAFF_ROLE_LABELS[staffRole] : user.username || user.email || 'PMO Staff'}
                  </p>
                </div>
              </div>
            </div>
            
            <div className="p-2">
              <button
                onClick={handleLogout}
                className="w-full flex items-center px-3 py-2 text-sm text-gray-700 hover:bg-gray-100 rounded-md transition-colors"
              >
                <LogOut className="h-4 w-4 mr-3" />
                Sign Out
              </button>
            </div>
          </div>
        </>
      )}
    </div>
  );
};

export default UserProfile;
